export const ACTIVITIES_BASE_PATH = 'activities';
